export const useHaptic = (type) => {

    const hapticFeedBack = () => {
        if (type === 'select') {
            return window.Telegram.WebApp.HapticFeedback.selectionChanged();
        }
        if (type === 'success') {
            return window.Telegram.WebApp.HapticFeedback.notificationOccurred("success");
        }

    }

    return {hapticFeedBack};

}